
define(
	'Klaviyo.EntryPoint'
,   [
		'Klaviyo.View'
	]
,   function (
		KlaviyoView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
            
            if (layout) {
				layout.on('afterShowContent', function () {
					var scriptTag = jQuery("script[src^='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XPh6FK']");
					if (!scriptTag.length) {
						jQuery('body').append(
							'<script async type="text/javascript" src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XPh6FK"></script>'
						);
					}
					setTimeout(function(){ 
						var _klOnsite = window._klOnsite || [];
						_klOnsite.push(['openForm', 'Xk2HkN']);
						_klOnsite.push(['openForm', 'TxqFua']);
					}, 500);
				});
                layout.addChildView('FooterContent', function() { 
					return new KlaviyoView({ container: container });
				});
            }
		}
	};
});
